import { Trans } from "@lingui/react";

export const ErrorFallback = ({ helpCenter }: { helpCenter: string }) => {
  return (
    <main className="page-container mb-16">
      <h1 className="text-center mt-16">
        <Trans id="errorFallback.title" message="Wops" />
      </h1>
      <p className="text-center">
        <Trans id="errorFallback.somethingWentWrong" message="Something went wrong." />
      </p>
      <p className="text-center">
        <Trans
          id="errorFallback.message"
          message="Try to refresh the page a bit later, or get more information at <link>help center</link>."
          // biome-ignore lint/a11y/useAnchorContent: There is actual text the screen-reader can use here as seen in the message above
          components={{ link: <a href={helpCenter} /> }}
        />
      </p>
      <img className="max-w-full" src="/assets/500.jpg" alt="Error" />
    </main>
  );
};
